import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useUserProfile } from 'modules/utils';
import { useSelector } from 'react-redux';
import { useGetInvitations } from 'shared/data/webApp/v2';

export const useIsMyAccountAvailable = () => {
    const profile = useUserProfile();

    const { data } = useGetInvitations();
    const noInvitations = !data?.items?.length;

    const companies = useSelector(selectors.company.companiesSelector);

    const isAccountOwnerOrManager =
        profile.account?.userRole === domain.AccountMemberRole.Administrator ||
        profile.account?.userRole === domain.AccountMemberRole.Manager;

    const isMemberOrUserManager =
        profile.account?.userRole === domain.AccountMemberRole.Member ||
        profile.account?.userRole === domain.AccountMemberRole.UserManager;

    const isPotentialAccountOwner = !companies.length && noInvitations && !isMemberOrUserManager;

    return isAccountOwnerOrManager || isPotentialAccountOwner;
};
